/**
 * Module dependencies.
 */

import { Description } from 'components/atoms/description/description';
import { Link } from 'components/atoms/link/link';
import { Title } from 'components/atoms/title/title';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-template-areas:
    'image title'
    'image content'
    'image action';

  max-width: 80vw;
  margin: 0 auto;
  margin-top: 60px;
  align-items: stretch;
  column-gap: 60px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'title'
      'image'
      'content'
      'action';
  }
`;

/**
 * Export `AboutCompanyWrapper` styled component.
 */

export const ImageWrapper = styled.div`
  grid-area: image;
  width: 100%;
  height: 100%;

  @media (max-width: 1024px) {
    max-width: 300px;
    margin: 0 auto;
    margin-bottom: 24px;
    margin-top: 24px;
  }

  @media (max-width: 480px) {
    max-width: initial;
    margin-left: -48px;
    margin-right: 0px;
    width: calc(100% + 96px);
  }
`;

/**
 * Export `Image` styled component.
 */

export const Image = styled.img`
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 480px) {
    border-radius: 0;
    box-shadow: initial;
  }
`;

/**
 * Export `CompanyTitle` styled component.
 */

export const CompanyTitle = styled(Title)`
  grid-area: title;
  margin-bottom: 12px;

  @media (max-width: 1024px) {
    text-align: center;
  }

  @media (min-width: 1024px) {
    font-size: 30px;
    left-align: left !important;
  }
`;

/**
 * Export `CompanyDescription` styled component.
 */

export const CompanyDescription = styled(Description)`
  color: #555;
  grid-area: content;
  margin-bottom: 24px;
  line-height: 23px;

  li {
    margin-bottom: 4px;
    position: relative;
    margin-left: 32px;

    &::before {
      position: absolute;
      content: '✓';
      left: -24px;
      color: green;
    }
  }

  ul {
    margin-bottom: 32px;
    margin-top: 32px;
  }
`;

/**
 * Export `LinkAction` styled component.
 */

export const LinkAction = styled(Link)`
  grid-area: action;
`;
